/**
 * @fileoverview Privilege keys for the organisation's bank details.
 * @description The privilege only a Super Admin holds (the backend's
 * SALES_CRM.ORGANISATION_DETAILS.UPDATE), which decides who may edit the organisation details; the
 * dialog itself opens from My Page and from the header's account menu. Shared so the page and the
 * app shell name it once.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

/** Held only by the Super Admin: may edit (or first create) the organisation details. */
export const ORGANISATION_UPDATE_PRIVILEGE = 'sales:organisation:update'

/** Held by every sales role and the Super Admin: may open the organisation details to read them. */
export const ORGANISATION_VIEW_PRIVILEGE = 'sales:my-page:view'
